import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Account, LoyaltyPlan, StoreConfig, FeaturedContent, ConfigService } from 'ngx-web-api';
import { BreakpointService } from '../../services/breakpoint.service';
import { Observable, Subject, of } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { OrderingUtilsService } from 'app/core/services/ordering-utils.service';
import { LoyaltySubscription } from 'ngx-web-api/lib/models/core/loyalty-subscription.model';

@Component({
  selector: 'fts-plain-account-menu',
  templateUrl: './plain-account-menu.component.html',
  styleUrls: ['./plain-account-menu.component.scss'],
})
export class PlainAccountMenuComponent implements OnInit, OnDestroy {
  @Input()
  account: Account;
  @Input()
  store: StoreConfig;
  @Input()
  compactHeader: boolean;
  @Input()
  compactAccountMenu: boolean;
  @Input()
  isInHome: boolean;
  @Input()
  isInIntro = false;
  @Input()
  featuredContents: FeaturedContent[];

  @Output()
  login: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  logout: EventEmitter<void> = new EventEmitter<void>();

  isSelfOrder$: Observable<boolean>;
  loyaltyPlan: LoyaltyPlan;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    public breakPointService: BreakpointService,
    private orderingUtilsService: OrderingUtilsService,
    private configService: ConfigService
  ) {
    this.isSelfOrder$ = this.orderingUtilsService.isSelfOrder$;
  }

  ngOnInit() {
    this.configService.loyaltyPlan$
      .pipe(
        catchError(() => of(null)),
        takeUntil(this.destroy$)
      )
      .subscribe(plan => {
        this.loyaltyPlan = plan;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get hasActiveLoyaltySubscriptions(): boolean {
    if (!this.store.hasLoyalty || !this.loyaltyPlan?.loyaltySubscriptions) return false;
    const activeSubs = this.loyaltyPlan.loyaltySubscriptions.filter((sub: LoyaltySubscription) => sub.active);
    return activeSubs.length > 0;
  }

  handleLogin() {
    this.login.emit();
  }

  handleLogout() {
    this.logout.emit();
  }
}
